// ServiceTabs.js
import { Tabs, Tab, Box } from '@mui/material';
import { AppStyle } from '../../value/AppConst';

/**
 * 하위 탭 메뉴를 갖는 구조에서 탭 메뉴들을 표시하는 컴포넌트
 * 사용 예: BbsPkg.js에서 하위의 AnnounceBbs, VehAllocBbs, UpdateBbs, UserBbs 컴포넌트를 표시할 때
 * 이 컴포넌트 인스턴스를 하나 선언하고 해당 컴포넌트들에게 viewServiceTags 속성으로 전달한다.
 * 탭을 누르면 onChangeTab 함수가 호출되고, 해당 함수는 이 컴포넌트를 선언한 최상위 컴포넌트(이 예에서는 BbsPkg)에서 구현한다.
 * (구현 내용은 menuRequestRepo로 메뉴를 만들어 던져주는 것)
 * @param {*} param0 
 * @returns 
 */
export default function ServiceTabs({
    menu,
    parentMenu,
    onChangeTab,
}) {
    return(
        <Box
            style={{
                width:'100%',
                marginBottom:5, paddingLeft: 20,
                backgroundColor: '#eee', boxSizing: 'border-box', 
            }}
        >
            <Tabs value={menu.menuId} onChange={(e, v) => onChangeTab(v)}
                style={{
                    width:'100%', // marginLeft: 20,
                    borderBottom: AppStyle.BorderCCC,
                }}
            >
                {
                    parentMenu.children &&
                    parentMenu.children.map((sib) => {
                        return(
                            <Tab key={sib.menuId} label={sib.menuName} value={sib.menuId} />
                        )
                    })
                }
            </Tabs>
        </Box>
    );
}